"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "EtlManualTriggerResourceLog", {
    enumerable: true,
    get: function() {
        return EtlManualTriggerResourceLog;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _baseresourcelog = require("../base-resource-log");
const EtlManualTriggerDomainModel = _zod.z.enum([
    "all",
    "employee",
    "review",
    "goal",
    "survey"
]);
const EtlManualTriggerStatusModel = _zod.z.enum([
    "started",
    "queued",
    "processing",
    "completed"
]);
/**
 * Items queued for processing. Most domains queue plain ObjectIds; the survey domain
 * also queues survey response items that carry metadata.
 **/ const EtlManualTriggerQueuedItemModel = _zod.z.union([
    _zod.z.instanceof(_bson.ObjectId),
    _zod.z.object({
        _id: _zod.z.instanceof(_bson.ObjectId),
        metadata_id: _zod.z.instanceof(_bson.ObjectId),
        metadata_name: _zod.z.string()
    })
]);
const EtlManualTriggerResourceLog = _baseresourcelog.BaseResourceLog.extend({
    resource_type: _zod.z.literal("etl"),
    change_type: _zod.z.literal("manual-trigger"),
    data: _zod.z.object({
        domain: EtlManualTriggerDomainModel,
        status: EtlManualTriggerStatusModel,
        started_at: _zod.z.date(),
        completed_at: _zod.z.date().nullish(),
        /** Write-once snapshot of the items queued for processing. Not modified during the run. */ objects_to_process: _zod.z.array(EtlManualTriggerQueuedItemModel).nullish(),
        /** Total number of queued items. Written once alongside the snapshot. */ total_objects_count: _zod.z.number().nullish(),
        /** Count of items processed successfully. Incremented as the run progresses. */ success_processed_count: _zod.z.number().nullish(),
        /** Count of items that failed to process. Incremented as the run progresses. */ fail_processed_count: _zod.z.number().nullish(),
        /** Objects that have failed to process. Kept as a list for troubleshooting. */ fail_processed_objects: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)).nullish(),
        /** @deprecated Successfully processed objects, tracked on runs that predate the count fields. */ success_processed_objects: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)).nullish()
    })
});
